import { useI18n } from '#/hooks/useI18n';
import { Document } from '#/models';
import { Invoice } from '#/models/invoice/Invoice';
import { FC, Key } from 'react';
import { DocumentsKeys } from '#/hooks/api/documents/Documents.keys';
import { API } from '#/lib/network/API';
import { InvoiceHelper } from '#/models/helpers/invoice/InvoiceHelper';
import { AsyncComponent } from '../async/AsyncComponent';
import { useGet } from '#/hooks';
import { RenderInvoiceDocumentTabContent } from './RenderInvoiceDocumentTabContent';
import { Tabs } from '@zazume/zzm-base';

interface RenderInvoiceDocumentsProps {
  document: Document;
  linkedInvoice: Invoice;
  close: () => void;
  onTabChange: (name: string) => void;
  onNextClick?: (id: string) => void;
  onPreviousClick?: (id: string) => void;
  hasNext?: boolean;
  hasPrevious?: boolean;
}

export const RenderInvoiceDocuments: FC<RenderInvoiceDocumentsProps> = ({ document, linkedInvoice, close, onTabChange, onNextClick, onPreviousClick, hasNext, hasPrevious }) => {
  const { t } = useI18n();
  const apiResult = useGet<Document>(DocumentsKeys.byId(linkedInvoice.documentId), API.documents.get(linkedInvoice.documentId));

  return (
    <>
      <AsyncComponent apiResult={apiResult}>
        {(linkedDocument) => {
          const linkedInvoiceIsCreditNote = new InvoiceHelper(linkedInvoice).isCreditNote();
          const creditNoteDocument = linkedInvoiceIsCreditNote ? linkedDocument : document;
          const invoiceDocument = linkedInvoiceIsCreditNote ? document : linkedDocument;

          const onSelectionChange = (key: Key) => {
            const name = key === 'regular' ? invoiceDocument.filename : creditNoteDocument.filename;
            onTabChange(name);
          };

          return (
            <Tabs label="Invoice tabs" defaultSelectedKey={linkedInvoiceIsCreditNote ? 'regular' : 'credit-note'} onSelectionChange={onSelectionChange}>
              <Tabs.Tab key="regular" title={t('documents.types.invoice')}>
                <RenderInvoiceDocumentTabContent
                  document={invoiceDocument}
                  close={close}
                  onNextClick={onNextClick}
                  onPreviousClick={onPreviousClick}
                  hasNext={hasNext}
                  hasPrevious={hasPrevious}
                />
              </Tabs.Tab>
              <Tabs.Tab key="credit-note" title={t('documents.types.creditNoteInvoice')}>
                <RenderInvoiceDocumentTabContent
                  document={creditNoteDocument}
                  close={close}
                  onNextClick={onNextClick}
                  onPreviousClick={onPreviousClick}
                  hasNext={hasNext}
                  hasPrevious={hasPrevious}
                />
              </Tabs.Tab>
            </Tabs>
          );
        }}
      </AsyncComponent>
    </>
  );
};
